import { registerCapability } from '../../platform/capability-registry';
import { ModelSubscriptionProviderBlock } from './ModelSubscriptionProviderBlock';
import { MS_PROVIDER_FIELD_KEY_LIST } from './fieldKeys';
import { resolveModelSubscriptionProviderPaths } from './resolvePaths';
import type { ModelSubscriptionProviderBlockOptions } from './types';

registerCapability<ModelSubscriptionProviderBlockOptions>({
  key: 'model-subscription-provider',
  fields: [...MS_PROVIDER_FIELD_KEY_LIST],
  component: ModelSubscriptionProviderBlock,
  defaultPaths: (prefix) => resolveModelSubscriptionProviderPaths(prefix),
  resolvePaths: (prefix) => resolveModelSubscriptionProviderPaths(prefix),
});

export { ModelSubscriptionProviderBlock } from './ModelSubscriptionProviderBlock';
export { MS_PROVIDER_TOKEN_RESOURCE_CODE, MS_PROVIDER_PRICING_FIELD } from './constants';
export { buildMsProviderVendorDeviceFormPatch, readMsProviderVendorDevice } from './vendorDeviceMapping';
